export enum ColumnDataType {
  Text = 'text',
  Number = 'number',
  Currency = 'currency',
  Link = 'link',
  Custom = 'custom',
  Form = 'form',
}

/**
 * Configuration interface for table component setup and display options.
 * Defines the structure and behavior of data tables throughout the application.
 *
 * @interface ITableConfiguration
 *
 * @property {string[]} columnList - Array of column identifiers to be displayed in the table
 * @property {string[]} filterList - Array of field names that can be used for filtering table data
 * @property {boolean} showFilter - Flag to control visibility of the filter UI component
 * @property {any} mapper - Mapping configuration for transforming data before display
 * @property {string} tableTitle - Display title shown at the top of the table
 * @property {string} tableType - Type identifier for the table, used for styling or behavior differentiation
 * @property {number[]} pageSizeOptions - Available options for number of rows per page in pagination
 * @property {number} pageSize - Default number of rows to display per page
 * @property {string} [img] - Optional image URL or path to display with the table (e.g., header icon)
 * @property {number} [pageLength] - Optional total number of records available, used for pagination calculations
 *
 * @example
 * const config: ITableConfiguration = {
 *   columnList: ['id', 'name', 'email'],
 *   filterList: ['name', 'email'],
 *   showFilter: true,
 *   mapper: {},
 *   tableTitle: 'Users',
 *   tableType: 'user-table',
 *   pageSizeOptions: [10, 25, 50],
 *   pageSize: 10
 * };
 */
export interface ITableConfiguration {
  columnList: string[];
  filterList: string[];
  showFilter: boolean;
  mapper: any;
  tableTitle: string;
  tableType: string;
  pageSizeOptions: number[];
  pageSize: number;
  img?: string;
  pageLength?: number;
}

export interface ITableMatcher {
  fieldName: string;
  displayColumn: string;
  dataTypeColumn: ColumnDataType;
  sticky?: boolean;
  stickyEnd?: boolean;
  filterName: string;
  sort?: boolean;
}

export interface IAddNewDefaultAttribute {
  siteAttribute: string;
  attributeType: string;
  siteAttributeValue: number;
}
